var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"ma-2 mt-0 rounded-br-xl rounded-bl-xl pr-2 no-print",attrs:{"app":"","color":"white","elevation":"1"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.toggleDrawer}},[_c('v-app-bar-nav-icon',{attrs:{"color":"secondary"}})],1),_c('v-spacer'),_c('user-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }